<td class="center">{{app}}</td>
<td class="center">{{model}}</td>
<td class="center">{{version}}</td>
<td class="center">{{build}}</td>
<td>{{description}}</td>
<td>{{user}}</td>
